import { render, staticRenderFns } from "./VideoImg.vue?vue&type=template&id=67df326e&scoped=true"
import script from "./VideoImg.vue?vue&type=script&lang=js"
export * from "./VideoImg.vue?vue&type=script&lang=js"
import style0 from "./VideoImg.vue?vue&type=style&index=0&id=67df326e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df326e",
  null
  
)

export default component.exports